const createSupportPin = (phoneNumber) => {
  phoneNumber = phoneNumber.toString().trim().replace(/[^0-9]/g, '');
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
};

export default createSupportPin;



// WEBPACK FOOTER //
// ./src/app/admin/services/utils/createSupportPin.js